import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime'
import { forwardRef } from 'react'
const SvgBrandIconBrand = (props, ref) =>
  _jsxs('svg', {
    viewBox: '0 0 48 48',
    xmlns: 'http://www.w3.org/2000/svg',
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    ref: ref,
    ...props,
    children: [
      _jsx('circle', { cx: 24, cy: 24, r: 24, fill: '#fcf7f7' }),
      _jsx('path', {
        d: 'M29.533 18.126a2.757 2.757 0 1 1-3.898.093 2.74 2.74 0 0 1 2.07-.843c-.61 1.243-.738 2.38-.251 3.27q.106.195.247.368a.497.497 0 0 0 .703.073.5.5 0 0 0 .072-.704 1.5 1.5 0 0 1-.145-.217c-.341-.624-.2-1.53.364-2.58.301.127.587.302.838.54M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24m-8.98.478-9.078-8.656c1.414-1.64 3.63-3.437 6.559-5.04a28 28 0 0 1 4.632-2.033c.016-.005.027-.017.042-.024q-.36-.403-.736-.789a29 29 0 0 0-4.419 1.97c-2.886 1.579-5.232 3.437-6.789 5.238L22.74 8.956a1.757 1.757 0 0 0-2.484.059L1.486 28.704c1.926 9.236 9.41 16.452 18.782 17.989L39.08 26.96a1.756 1.756 0 0 0-.06-2.483m2.099-5.253c1.65-.903 3.19-1.95 4.511-3.042q-.18-.494-.382-.98c-1.325 1.129-2.907 2.214-4.61 3.145-.949.52-1.918.984-2.88 1.382a.5.5 0 1 0 .382.924c.995-.41 1.998-.892 2.979-1.429',
      }),
    ],
  })
const ForwardRef = forwardRef(SvgBrandIconBrand)
export default ForwardRef
